import React from "react";
import { Sun, Sunrise, Moon, Calendar, Sparkles } from "lucide-react";
import moment from "moment";

const WelcomeSection = ({ studentName }) => {
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) {
      return { text: "Good Morning", icon: Sunrise };
    } else if (hour < 17) {
      return { text: "Good Afternoon", icon: Sun };
    } else {
      return { text: "Good Evening", icon: Moon };
    }
  };

  const greeting = getGreeting();
  const GreetingIcon = greeting.icon;
  const today = moment().format("dddd, MMMM D, YYYY");

  return (
    <div className="relative overflow-hidden bg-gradient-to-r from-blue-600 to-cyan-500 rounded-2xl shadow-lg p-6 mb-6">
      {/* Decorative circles */}
      <div className="absolute -top-10 -right-10 w-40 h-40 bg-white/10 rounded-full"></div>
      <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-white/10 rounded-full"></div>
      
      <div className="relative flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        {/* Left - Greeting */}
        <div className="flex items-center gap-4">
          <div className="p-3 rounded-xl bg-white/20">
            <GreetingIcon className="w-6 h-6 text-white" />
          </div>
          <div>
            <div className="flex items-center gap-2">
              <h1 className="text-2xl font-bold text-white">
                {greeting.text}, {studentName || "Student"}!
              </h1>
              {/* <Sparkles className="w-5 h-5 text-yellow-300" /> */}
            </div>
            <p className="text-blue-100 text-sm mt-1">
              Let's Start Learning
            </p>
          </div>
        </div>

        {/* Right - Date */}
        <div className="flex items-center gap-2 text-white bg-white/20 px-4 py-2 rounded-lg">
          <Calendar className="w-4 h-4" />
          <span className="text-sm font-medium">{today}</span>
        </div>
      </div>
    </div>
  );
};

export default WelcomeSection;